function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpwardArrowIconWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M0 20.201 14.445 5.756a17.435 17.435 0 0 1-7.974-.828L7.824.076a24.988 24.988 0 0 0 13.167.94l1.842 1.842c-.94 4.29-.187 10.232 1.167 13.017l-4.853 1.505a17.162 17.162 0 0 1-1.016-7.9L3.686 23.923z",
    style: {
      fill: "#fff"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpwardArrowIconWhite);
export default __webpack_public_path__ + "static/media/upward-arrow-icon-white.2bf653d43b7b186023ae9c78ca27e8b8.svg";
export { ForwardRef as ReactComponent };